import { StyleSheet } from 'react-native'
import { DS } from '../../design-system'

export const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  bottomSheetHandleStyle: {
    backgroundColor: DS.palette['Brand/Cream'],
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingBottom: 0,
    height: 32
  },

  bottomSheetIndicatorStyle: {
    backgroundColor: 'gray',
    height: 2,
    width: 44
  }
})
